import React from 'react';
import { Star, Quote } from 'lucide-react';
import './Testimonials.css';

const testimonialsData = [
  {
    name: 'Antonala Horvat',
    role: 'Učenica srednje škole',
    image: null,
    rating: 5,
    text: 'Zahvaljujući podukama iz matematike, moja ocjena se popravila s 2 na 4! Objašnjenja su jasna i razumljiva, a pristup izuzetno profesionalan.'
  },
  {
    name: 'Noan Sirotić',
    role: 'Računovođa',
    image: null,
    rating: 5,
    text: 'Excel obuka mi je ogromno pomogla u svakodnevnom poslu. Sada mogu samostalno kreirati kompleksne izvještaje i analize. Preporuka!'
  },
  {
    name: 'Petra Novak',
    role: 'Početnica u web developmentu',
    image: null,
    rating: 5,
    text: 'Odlična edukacija iz ReactJS-a! Od nule sam naučila izraditi modernu web aplikaciju. Stručno, strpljivo i s puno praktičnih primjera.'
  },
  {
    name: 'Ivan Babić',
    role: 'Voditelj prodaje',
    image: null,
    rating: 5,
    text: 'Zahvaljujući profesionalno napisanom životopisu i motivacijskom pismu, dobio sam posao iz prvog pokušaja! Odlična usluga!'
  }
];

const Testimonials = () => {
  return (
    <section id="testimonials" className="testimonials-section">
      <div className="testimonials-container">
        <div className="section-header">
          <span className="section-badge">Preporuke</span>
          <h2 className="section-title">Što kažu naši klijenti</h2>
          <p className="section-description">
            Zadovoljstvo polaznika i klijenata je naš najveći uspjeh. Pročitajte što kažu oni koji su već iskusili naše usluge.
          </p>
        </div>

        <div className="testimonials-grid">
          {testimonialsData.map((testimonial, index) => (
            <div key={index} className="testimonial-card">
              <Quote className="quote-icon" size={40} />
              
              <div className="testimonial-rating">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} size={18} fill="#f59e0b" stroke="#f59e0b" />
                ))}
              </div>

              <p className="testimonial-text">{testimonial.text}</p>

              <div className="testimonial-author">
                <div className="author-avatar">
                  {testimonial.name.charAt(0)}
                </div>
                <div className="author-info">
                  <div className="author-name">{testimonial.name}</div>
                  <div className="author-role">{testimonial.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
